import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FunctionalComponent } from 'preact';
import { route, useRouter } from 'preact-router';

import { useIsHomePageVariant } from '@/components/ab-test/LandingPageExperiment';
import { useSelector } from '@/redux/helper';

import Menu from './Menu';
import Search from './Search';
import style from './style.scss';

interface HeaderProps {
  title: string;
}

const Header: FunctionalComponent<HeaderProps> = ({ title }) => {
  const [currentRoute] = useRouter();
  const habitat = useSelector((store) => store.allHabitats).find(
    (item) => item?.slug === currentRoute?.matches?.habitatSlug,
  );
  const isHomePageVariant = useIsHomePageVariant();

  return (
    <header className={style.mobileHeader}>
      {habitat ? (
        <>
          <button type="button" className={style.backButton} onClick={() => route(isHomePageVariant ? '/habitats' : '/map')}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <h1>
            <p>{habitat.animal}</p>
            <span>{habitat?.zoo?.name}</span>
          </h1>
        </>
      ) : (
        <>
          <Menu />
          <h1>{title}</h1>
          <Search />
        </>
      )}
    </header>
  );
};

export default Header;
